import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { SITE } from "@/lib/siteData";

export default function Contact() {
  return (
    <section id="contact" className="py-20 lg:py-32 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <div className="text-sm font-semibold uppercase tracking-widest text-blue-600 mb-4">Contact</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-slate-900 tracking-tight">
              Venez nous rencontrer
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Le garage est ouvert du mardi au samedi. Passez nous voir ou appelez-nous pour toute question.
            </p>

            <div className="mt-10 space-y-5">
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(SITE.address.full)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-4 p-5 bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 rounded-xl transition-colors group"
                data-testid="contact-address-link"
              >
                <div className="w-11 h-11 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Adresse</div>
                  <div className="font-semibold text-slate-900 mt-1">{SITE.address.street}</div>
                  <div className="text-sm text-slate-600">{SITE.address.zip} {SITE.address.city}</div>
                </div>
                <ExternalLink className="w-4 h-4 text-slate-400 group-hover:text-blue-600 self-center" />
              </a>

              <a
                href={SITE.phoneTel}
                className="flex gap-4 p-5 bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 rounded-xl transition-colors"
                data-testid="contact-phone-link"
              >
                <div className="w-11 h-11 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Téléphone</div>
                  <div className="font-semibold text-slate-900 mt-1">{SITE.phoneDisplay}</div>
                  <div className="text-sm text-slate-600">Appel direct ou dépannage</div>
                </div>
              </a>

              <a
                href={`mailto:${SITE.email}`}
                className="flex gap-4 p-5 bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 rounded-xl transition-colors"
                data-testid="contact-email-link"
              >
                <div className="w-11 h-11 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Email</div>
                  <div className="font-semibold text-slate-900 mt-1">{SITE.email}</div>
                  <div className="text-sm text-slate-600">Réponse rapide</div>
                </div>
              </a>

              <div className="flex gap-4 p-5 bg-slate-50 border border-slate-200 rounded-xl" data-testid="contact-hours">
                <div className="w-11 h-11 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Horaires</div>
                  <div className="font-semibold text-slate-900 mt-1">{SITE.hours.days}</div>
                  <div className="text-sm text-slate-600">{SITE.hours.time} • {SITE.hours.closed}</div>
                  <div className="text-xs font-semibold text-red-600 mt-2 inline-flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 bg-red-600 rounded-full animate-pulse" />
                    {SITE.hours.emergency}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-xl border border-slate-200 min-h-[400px] lg:min-h-[600px]">
            <iframe
              title="Carte Sphère Auto"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(SITE.address.full)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 400 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="contact-map"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
